import React from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

export const ParamsContext = React.createContext();

const ParamsProvider = (props) => {
  const parsedParams = queryString.parse(useLocation().search);
  const dataParams = { ...parsedParams };
  return (
    <ParamsContext.Provider value={dataParams}>
      {props.children}
    </ParamsContext.Provider>
  );
}

export default ParamsProvider;